import { Box } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';

import { TextBold } from 'UiKit/typography';

import styles from './styles.module.css';

const Head = () => {
  const { t } = useTranslation('reschedule');
  return (
    <Box className={styles['head__container']}>
      <TextBold className={styles['title__text']}>
        {t('title')}
      </TextBold>
    </Box>
  );
};

export default Head;
